export const SERASA_LOOKUP_HML_KEY = "@UltragazEmpresarial:serasaLookupHml";

const PROD_ENVS = ["build-prod"];
const HML_ENVS = ["homolog", "build-homolog"];

const isHmlFlagOn = (): boolean => {
  try {
    return localStorage.getItem(SERASA_LOOKUP_HML_KEY) === "true";
  } catch {
    return false;
  }
};

export const isSerasaLookupEnabled = (): boolean => {
  const env = process.env.REACT_APP_ENV;

  if (PROD_ENVS.includes(env)) return true;
  if (HML_ENVS.includes(env)) return isHmlFlagOn();

  return false;
};
